export type SecuritySuggesterItem =
  | {
      id: number;
      name: string;
      category: string;
      type: SecuritySuggesterItemType.List;
      disabled: boolean;
      itemsCount: number; // Required for List type
      ticker?: never;
      stockExchange?: never;
    }
  | {
      id: number;
      name: string;
      category: string;
      type: SecuritySuggesterItemType.Individual;
      disabled: boolean;
      ticker?: string;
      stockExchange?: string;
    };

export enum SecuritySuggesterItemType {
  List,
  Individual
}
